// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./PaymentUtils.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./RecoilAtomsV2.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./UnifiedHelpersV2.bs.js";

function paymentListLookupNew(paymentMethodListValue) {
  var walletsList = [];
  var otherPaymentList = [];
  paymentMethodListValue.paymentMethodsEnabled.forEach(function (item) {
        if (item.paymentMethodType === "card") {
          otherPaymentList.push("card");
          return ;
        }
        
      });
  return {
          walletsList: Utils$OrcaPaymentPage.removeDuplicate(walletsList),
          otherPaymentList: Utils$OrcaPaymentPage.removeDuplicate(otherPaymentList)
        };
}

function useGetPaymentMethodListV2(paymentOptions) {
  var methodslist = Recoil.useRecoilValue(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  return React.useMemo((function () {
                if (typeof methodslist !== "object") {
                  return [
                          [],
                          []
                        ];
                }
                if (methodslist.TAG !== "LoadedV2") {
                  return [
                          [],
                          []
                        ];
                }
                var match = paymentListLookupNew(methodslist._0);
                var otherPaymentList = match.otherPaymentList;
                var payments = Utils$OrcaPaymentPage.removeDuplicate(Belt_Array.concatMany([
                          paymentOptions,
                          otherPaymentList
                        ]));
                return [
                        payments,
                        otherPaymentList
                      ];
              }), [methodslist]);
}

function getCreditFieldsRequired(paymentManagementListValue) {
  return paymentManagementListValue.paymentMethodsEnabled.filter(function (item) {
              if (item.paymentMethodType === "card") {
                return item.paymentMethodSubtype === "credit";
              } else {
                return false;
              }
            });
}

function getPaymentMethodTypeFromListV2(paymentsListValueV2, paymentMethod, paymentMethodType) {
  return Core__Option.getOr(paymentsListValueV2.paymentMethodsEnabled.find(function (item) {
                  if (item.paymentMethodSubtype === paymentMethodType) {
                    return item.paymentMethodType === paymentMethod;
                  } else {
                    return false;
                  }
                }), UnifiedHelpersV2$OrcaPaymentPage.defaultPaymentMethods);
}

function usePaymentMethodTypeFromListV2(paymentsListValueV2, paymentMethod, paymentMethodType) {
  return React.useMemo((function () {
                return getPaymentMethodTypeFromListV2(paymentsListValueV2, paymentMethod, PaymentUtils$OrcaPaymentPage.getPaymentMethodName(paymentMethod, paymentMethodType));
              }), [
              paymentsListValueV2,
              paymentMethod,
              paymentMethodType
            ]);
}

export {
  paymentListLookupNew ,
  useGetPaymentMethodListV2 ,
  getCreditFieldsRequired ,
  getPaymentMethodTypeFromListV2 ,
  usePaymentMethodTypeFromListV2 ,
}
/* react Not a pure module */
